import { render, staticRenderFns } from "./EmbeddedIndex.vue?vue&type=template&id=6887b832&scoped=true&"
import script from "./EmbeddedIndex.vue?vue&type=script&lang=js&"
export * from "./EmbeddedIndex.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedIndex.vue?vue&type=style&index=0&id=6887b832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887b832",
  null
  
)

export default component.exports